import { COMPONENT_COACH } from '../constants';

export const setCurrentCohortId = (currentCohortId, bootcampId) => {
  const cohortIdsByBootcamp = JSON.parse(localStorage.getItem(COMPONENT_COACH.COACH_COHORT_IDS) || '{}');
  cohortIdsByBootcamp[bootcampId] = currentCohortId;
  localStorage.setItem(COMPONENT_COACH.COACH_COHORT_IDS, JSON.stringify(cohortIdsByBootcamp));
};
